import React from 'react';
import PropTypes from 'prop-types';
import { cloneObject } from '../../../common/utils';
import { allowedUnorderedListProps, UnorderedList } from '../UnorderedList';
import { allowedListItemProps } from './_allowedPropTypes';
import CardListItem from './_CardListItem';

const getFinalProp = function (prop, dataObject) {
  return typeof (prop) === 'function' ? prop(dataObject) : prop;
};

const CardListController = receivedProps => {
  const {
    textNoResults,
    listData,
    listItemData: {
      key,
      title: listItemTitle,
      classNames: listItemClasses = [],
      cardSize,
      cardMargin,
      image,
      caption
    }
  } = receivedProps;

  const listProps = cloneObject(receivedProps, {}, ['listData', 'listItemData']);
  const { classNames: listClasses = [] } = listProps;

  listClasses.push('card-list');
  listProps.htmlAttributes = {
    className: listClasses.join(' ')
  };

  if (!listData || listData.length < 1) {
    return <p className='text-description'>{textNoResults}</p>;
  }

  return (
    <UnorderedList {...listProps}>
      {listData.map(dataObject => (
        <CardListItem
          key={getFinalProp(key, dataObject)}
          title={getFinalProp(listItemTitle, dataObject)}
          classNames={getFinalProp(listItemClasses, dataObject)}
          cardSize={getFinalProp(cardSize, dataObject)}
          cardMargin={getFinalProp(cardMargin, dataObject)}
          image={getFinalProp(image, dataObject)}
          caption={getFinalProp(caption, dataObject)}
        />
      ))}
    </UnorderedList>
  );
};

CardListController.propTypes = {
  ...allowedUnorderedListProps,
  classNames: PropTypes.arrayOf(PropTypes.string),
  textNoResults: PropTypes.string.isRequired,
  listData: PropTypes.arrayOf(PropTypes.object).isRequired,
  listItemData: PropTypes.shape(allowedListItemProps).isRequired
};

export default CardListController;